<template>
  <div v-if="voting">
    <h4>Голосование</h4>
    <div>Количество вариантов для выбора - {{ voting.answersCount }}</div>
    <b-card v-for="variant of this.voting.variants" :key="variant.index" class="mb-2">
      <div class="d-flex justify-content-between">
        <h5>{{ variant.index + 1 }}. {{ variant.title }}</h5>
        <b-button
          :disabled="isVoted || !isAvailable"
          class="ml-auto mb-2 vote-choice-button"
          :variant="chosenVariants.includes(variant.index) ? 'outline-primary' : 'primary'"
          @click="() => chooseVariant(variant.index)"
        >
          <icon-base
            class="icon mr-1"
            :icon-name="'like'"
            :viewBox="'0 0 478.2 478.2'"
          >
            <icon-like />
          </icon-base>
        </b-button>
      </div>
      <p v-html="variant.description" />
    </b-card>
    <div class="my-2">
      <h5>Комментарий к выбору</h5>
      <b-form-textarea
        :disabled="isVoted || !isAvailable"
        v-model="userComment"
        placeholder="Введите комментарий"
        rows="4"
        no-resize
      />
    </div>
    <div class="text-center">
      <b-button
        variant="primary"
        class="my-2"
        v-if="!isVoted && isAvailable"
        :disabled="!(chosenVariants.length || userComment)"
        @click="openConfirmChoice">
        Подтвердить выбор
      </b-button>
      <b-button
        variant="primary"
        class="ml-1 my-2"
        @click="exportVotingResults"
        v-if="content.contentObject.status === 'опубликовано'
            && (hasRole('curator') || hasRole('admin'))">
        <em class="fas fa-file-excel mr-1"></em> Экспорт результатов
      </b-button>
    </div>
    <div v-if="isShowDiagram" class="mt-2">
      <VotingResults :updater="diagramUpdater"/>
    </div>
    <b-modal id="confirm-event-choice-modal" hide-footer centered>
      <template slot="modal-title">
        Подтверждение выбора
      </template>
      <p class="my-1 text-center">Вы уверены, что хотите подтвердить выбор? Перевыбор будет недоступен.</p>
      <b-row class="mt-4">
        <b-col><b-button block variant="primary" @click="makeChoice">
          Подтвердить
        </b-button></b-col>
        <b-col>
          <b-button block variant="outline-primary" @click="() => $bvModal.hide('confirm-event-choice-modal')">
            Отмена
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import IconBase from '@/components/content/likes/IconBase.vue'
import IconLike from '@/components/content/likes/IconLike.vue'
import moment from 'moment'
import VotingResults from '@/components/content/events/voting/choice/Results.vue'
import ContentApi from '@/api/content'

export default {
  name: 'Voting',
  components: {
    VotingResults,
    IconBase,
    IconLike
  },
  data() {
    return {
      chosenVariants: [],
      isVoted: false,
      userComment: '',
      diagramUpdater: 0
    }
  },
  computed: {
    ...mapGetters({
      hasRole: 'currentUser/hasRole',
      isEditMode: 'contentManager/isEditMode',
      content: 'content/getContent'
    }),
    voting() {
      return this.content.contentObject.votingSettings
        ? this.content.contentObject.votingSettings.choice
        : null
    },
    isAvailable() {
      if (this.voting) {
        return !this.voting.dateLimit
          || (moment().startOf('day').isSameOrAfter(this.voting.dateStart)
            && moment().startOf('day').isSameOrBefore(this.voting.dateEnd))
      }
      return false
    },
    isShowDiagram() {
      return this.content.contentObject.status === 'опубликовано'
        && ((this.voting.diagramStatus === 2 && this.isVoted && !this.voting.dateLimit)
          || (this.voting.diagramStatus !== 0 && this.voting.dateLimit
            && moment().startOf('day').isAfter(this.voting.dateEnd)))
    }
  },
  created() {
    if (this.content.contentObject.userChoice) {
      this.chosenVariants = this.content.contentObject.userChoice.variants
      this.isVoted = true
      this.userComment = this.content.contentObject.userChoice.comment
    }
  },
  methods: {
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    }),
    chooseVariant(index) {
      const indexOfVariant = this.chosenVariants.indexOf(index)
      let message = ''
      if (indexOfVariant > -1) {
        this.chosenVariants.splice(indexOfVariant, 1)
        message = `Выбор варианта успешно отменен. Осталось выбрать - ${this.voting
          .answersCount - this.chosenVariants.length}`
      } else if (this.chosenVariants.length < this.voting.answersCount) {
        this.chosenVariants.push(index)
        message = `Выбор варианта успешно выполнен. Осталось выбрать - ${this.voting
          .answersCount - this.chosenVariants.length}`
      } else {
        message = `Максимальное количество выбранных вариантов - ${this.voting
          .answersCount}. Для выбора нового отмените выбор одного из уже выбранных.`
      }
      this.pushToasts({
        title: 'Голосование',
        message,
        time: 3
      })
    },
    openConfirmChoice() {
      this.$bvModal.show('confirm-event-choice-modal')
    },
    async makeChoice() {
      this.$bvModal.hide('confirm-event-choice-modal')
      if (this.content.contentObject.status === 'опубликовано') {
        try {
          await ContentApi.addVoteChoiceOnEvent(this.content.contentObject.id, {
            variants: this.chosenVariants,
            comment: this.userComment
          })
          if (this.isShowDiagram) {
            this.diagramUpdater += 1
          }
          this.isVoted = true
          this.pushToasts({
            title: 'Голосование',
            message: 'Ваш голос учтён!',
            time: 5
          })
        } catch {
          this.pushToasts({
            title: 'Ошибка',
            error: true,
            message: 'Во время подтверждения участия произошла ошибка.',
            time: 5
          })
        }
      } else {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Подтверждение выбора не было выполнено, т.к. данное мероприятие не опубликовано.',
          time: 5
        })
        this.isVoted = true
      }
    },
    exportVotingResults() {
      if (this.content.contentObject.id) {
        ContentApi.exportVotingChoiceExcel(this.content.contentObject)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../sass/vendor/bootstrap/variables";
 .vote-choice-button {
   width: 55px;
 }
 .vote-choice-button .btn-outline-primary.disabled, .btn-outline-primary:disabled {
   color: $primary-color;
   background-color: transparent;
   border-color: $primary-color;
   cursor: cell !important;
 }
</style>
